import React from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

interface Props {
    onClick: () => void
}

const ProfileVideoButton = ({ onClick }: Props) => {
  return (
    <OverlayTrigger
      placement="right"
      delay={{ show: 250, hide: 400 }}
      overlay={(props: any) => (
        props.show = "true",
        <Tooltip id="button-tooltip" {...props}>
          Show video
        </Tooltip>
      )}
    >
      <FontAwesomeIcon
        className="text-xl mb-3"
        icon="video"
        style={{ cursor: "pointer" }}
        onClick={() => onClick()}
      />
    </OverlayTrigger>
  );
};

export default ProfileVideoButton;
